import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

const useDropdownButtonStyles = makeStyles(() => ({
  root: {
    '&': tw`text-center text-xs text-white bg-green-600 font-bold border-white border-0 border-l rounded-r-2xl py-2`,
    '&:hover': tw`bg-green-600`,
  },
}));

export default useDropdownButtonStyles;
